import { ReactNode } from "react"
import { Head, Link, usePage } from "@inertiajs/react"
import { Card } from "@/components/ui/card"
import { cn } from "@/lib/utils"

interface AdminLayoutProps {
  title: string
  children: ReactNode
}

const NAV_LINKS = [
  { href: "/", label: "Voltar ao site" },
  { href: "/admin", label: "Dashboard" },
  { href: "/admin/users", label: "Usuários" },
  { href: "/admin/orders", label: "Pedidos" },
  { href: "/admin/test_results", label: "Resultados" },
  { href: "/admin/analytics", label: "Analytics" },
]

export function AdminLayout({ title, children }: AdminLayoutProps) {
  const page = usePage()
  const currentPath = page.url || ""

  return (
    <div className="min-h-screen bg-muted/40">
      <Head title={title} />
      <div className="max-w-6xl mx-auto px-4 py-8 space-y-6">
        <Card className="p-4 md:p-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
              <p className="text-sm text-muted-foreground">Painel Administrativo</p>
              <h1 className="text-2xl md:text-3xl font-bold text-foreground">{title}</h1>
            </div>
            <nav className="flex flex-wrap gap-2">
              {NAV_LINKS.map((link) => {
                const isActive = link.href !== "/" && currentPath.startsWith(link.href)
                return (
                  <Link
                    key={link.href}
                    href={link.href}
                    className={cn(
                      "px-3 py-2 rounded-md text-sm font-medium border transition-colors",
                      isActive
                        ? "bg-primary text-primary-foreground border-primary"
                        : "bg-white text-foreground border-border hover:border-primary/50"
                    )}
                  >
                    {link.label}
                  </Link>
                )
              })}
            </nav>
          </div>
        </Card>
        {children}
      </div>
    </div>
  )
}
